// extracted by mini-css-extract-plugin
export default {"wrapper":"EditNote_wrapper__LaUfC","label":"EditNote_label__f1fjT","textarea":"EditNote_textarea__M43-5","error":"EditNote_error__vwZgW","resize":"EditNote_resize__ZH7pS"};